"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayrollStatus = void 0;
exports.instanceOfPayrollStatus = instanceOfPayrollStatus;
exports.PayrollStatusFromJSON = PayrollStatusFromJSON;
exports.PayrollStatusFromJSONTyped = PayrollStatusFromJSONTyped;
exports.PayrollStatusToJSON = PayrollStatusToJSON;
exports.PayrollStatusToJSONTyped = PayrollStatusToJSONTyped;
/**
 *
 * @export
 */
exports.PayrollStatus = {
    Ineligible: 'ineligible',
    InvalidAddress: 'invalid_address',
    ContractNotSigned: 'contract_not_signed',
    Eligible: 'eligible',
    OnboardingStarted: 'onboarding_started',
    OnboardingCompleted: 'onboarding_completed'
};
function instanceOfPayrollStatus(value) {
    for (const key in exports.PayrollStatus) {
        if (Object.prototype.hasOwnProperty.call(exports.PayrollStatus, key)) {
            if (exports.PayrollStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function PayrollStatusFromJSON(json) {
    return PayrollStatusFromJSONTyped(json, false);
}
function PayrollStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function PayrollStatusToJSON(value) {
    return value;
}
function PayrollStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=PayrollStatus.js.map